module.exports = __webpack_public_path__ + "img/2.dc07ad61.png";